'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import type { MapMode } from '~/components/map';
import { useOverviewProgressStore } from '~/stores/tpv2/overviewProgressStore';
import { InlineMap } from './InlineMap';
import mapStyles from './InlineMap.module.css';
import { InlineMapFooterClient } from './InlineMapFooterClient';
type ItineraryDrawerShellProps = {
  headingId?: string;
  heading?: string;
  sectionId?: string;
  variant?: 'overview' | 'transport';
};
export function ItineraryDrawerShell(t0) {
  const $ = _c(31);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    headingId,
    heading,
    sectionId,
    variant
  } = t1;
  const t = useTranslations("journey");
  const [mode, setMode] = useState("compact");
  const setOverlayOpen = useOverviewProgressStore(_temp);
  let t2;
  if ($[2] !== setOverlayOpen) {
    t2 = next => {
      setMode(next);
      setOverlayOpen(next !== "compact");
    };
    $[2] = setOverlayOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleModeChange = t2;
  let t3;
  let t4;
  if ($[4] !== setOverlayOpen) {
    t3 = () => () => setOverlayOpen(false);
    t4 = [setOverlayOpen];
    $[4] = setOverlayOpen;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  const t5 = headingId ?? "trip-v2-map-heading";
  const t6 = headingId ?? "trip-v2-map-heading";
  let t7;
  if ($[7] !== heading || $[8] !== t) {
    t7 = heading ?? t("your_route");
    $[7] = heading;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <h2 id={t6} className={mapStyles.heading}>{t7}</h2>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = mode !== "compact" && mapStyles.mapCardOverlaid;
  let t10;
  if ($[13] !== t9) {
    t10 = clsx(mapStyles.mapCard, t9);
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== handleModeChange || $[16] !== mode || $[17] !== sectionId || $[18] !== variant) {
    t11 = <InlineMap mode={mode} onModeChange={handleModeChange} sectionId={sectionId} variant={variant} />;
    $[15] = handleModeChange;
    $[16] = mode;
    $[17] = sectionId;
    $[18] = variant;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== handleModeChange || $[24] !== mode) {
    t13 = mode === "compact" ? <div className={mapStyles.mobileFooter}><InlineMapFooterClient onExploreMap={() => handleModeChange("expanded")} /></div> : null;
    $[23] = handleModeChange;
    $[24] = mode;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t5 || $[29] !== t8) {
    t14 = <section className={mapStyles.section} aria-labelledby={t5}>{t8}{t12}{t13}</section>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t5;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp(s) {
  return s.setOverlayOpen;
}